import { Transforms } from 'slate';
import { CustomEditor, MentionElement } from 'slate/types/slate';

interface MentionReference {
  revisionId: string;
}

interface MentionCellSelection {
  start: { i: number; j: number };
  end?: { i: number; j: number };
}

export const insertMention = (editor: CustomEditor, reference: MentionReference, selection: MentionCellSelection) => {
  const mention: MentionElement = {
    type: 'mention',
    data: {
      referenceId: reference.revisionId,
      selection: [selection.start.i, selection.start.j], // always just check the first clicked node even if a range i selected
    },
    children: [{ text: '' }],
  };
  Transforms.insertNodes(editor, mention);
  Transforms.move(editor);
};
